import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
const getTimeUnits = ({
  durationInMs,
  unitsRequested = ["trim"],
  asUnit = false,
  roundup = false
}) => {
  if (typeof durationInMs !== "number") {
    throw new Error("Invalid typeof ms");
  }
  const ms = dayjs.duration(durationInMs);
  const isTrim = unitsRequested.includes("trim");
  const trimShape = isTrim && ms.years() ? ["years", "months", "days", "hours", "minutes", "seconds"] : ms.months() ? ["months", "days", "hours", "minutes", "seconds"] : ms.days() ? ["days", "hours", "minutes", "seconds"] : ms.hours() ? ["hours", "minutes", "seconds"] : ms.minutes() ? ["minutes", "seconds"] : ms.seconds() ? ["seconds"] : ["years", "months", "days", "hours", "minutes", "seconds"];
  const maxNonZeroRequestedUnit = unitsRequested.includes("years") && ms.years() > 0 ? "years" : unitsRequested.includes("months") && ms.months() > 0 ? "months" : unitsRequested.includes("days") && ms.days() > 0 ? "days" : unitsRequested.includes("hours") && ms.hours() > 0 ? "hours" : unitsRequested.includes("minutes") && ms.minutes() > 0 ? "minutes" : unitsRequested.includes("seconds") && ms.seconds() > 0 ? "seconds" : void 0;
  const minRequestedUnit = unitsRequested.includes("seconds") ? "seconds" : unitsRequested.includes("minutes") ? "minutes" : unitsRequested.includes("hours") ? "hours" : unitsRequested.includes("days") ? "days" : unitsRequested.includes("months") ? "months" : unitsRequested.includes("years") ? "years" : void 0;
  const isAll = unitsRequested.includes("all");
  const showUnit = (timeunit) => isAll || unitsRequested.includes(timeunit) || isTrim && trimShape.includes(timeunit);
  const isAsUnit = (timeunit) => asUnit && maxNonZeroRequestedUnit === timeunit;
  const shouldRoundUnit = (timeunit) => roundup && minRequestedUnit === timeunit;
  const getUnits = (unit) => [showUnit(unit), isAsUnit(unit), shouldRoundUnit(unit)];
  const [isYears, isAsYears, shouldRoundYears] = getUnits("years");
  const years = (isAsYears ? Math.floor(ms.asYears()) : ms.years()) + (shouldRoundYears && ms.asYears() > Math.floor(ms.asYears()) ? 1 : 0);
  const [isMonths, isAsMonths, shouldRoundMonths] = getUnits("months");
  const months = (isAsMonths ? Math.floor(ms.asMonths()) : ms.months()) + (shouldRoundMonths && ms.asMonths() > Math.floor(ms.asMonths()) ? 1 : 0);
  const [isDays, isAsDays, shouldRoundDays] = getUnits("days");
  const days = (isAsDays ? Math.floor(ms.asDays()) : ms.days()) + (shouldRoundDays && ms.asDays() > Math.floor(ms.asDays()) ? 1 : 0);
  const [isHours, isAsHours, shouldRoundHours] = getUnits("hours");
  const hours = (isAsHours ? Math.floor(ms.asHours()) : ms.hours()) + (shouldRoundHours && ms.asHours() > Math.floor(ms.asHours()) ? 1 : 0);
  const [isMinutes, isAsMinutes, shouldRoundMinutes] = getUnits("minutes");
  const minutes = (isAsMinutes ? Math.floor(ms.asMinutes()) : ms.minutes()) + (shouldRoundMinutes && ms.asMinutes() > Math.floor(ms.asMinutes()) ? 1 : 0);
  const [isSeconds, isAsSeconds, shouldRoundSeconds] = getUnits("seconds");
  const seconds = (isAsSeconds ? Math.floor(ms.asSeconds()) : ms.seconds()) + (shouldRoundSeconds && ms.asSeconds() > Math.floor(ms.asSeconds()) ? 1 : 0);
  return {
    ...isYears && { years },
    ...isMonths && { months },
    ...isDays && { days },
    ...isHours && { hours },
    ...isMinutes && { minutes },
    ...isSeconds && { seconds }
  };
};
var getTimeUnits_default = getTimeUnits;
export {
  getTimeUnits_default as default
};
